const HomepageStyles = () => {
  return (
    <style>
      {`
        .homepage .event-item {
            margin-bottom: 20px;
        }

        .homepage .sub-heading {
            font-weight: 700;
            margin-top: 0;
        }

        .homepage .landing-section-1 h1 {
            font-weight: 700;
            line-height: 56px;
            font-size: 48px;
            margin: 215px 0 25px;
        }

            .homepage .landing-section-1 h1 span {
                display: block;
                font-weight: 300;
                font-size: 44px;
            }

        .homepage .landing-section-1 p {
            margin-bottom: 30px
        }

        .homepage .landing-section-2 h3 {
            margin-top: 0;
            font-weight: 700;
            font-size: 28px;
        }

        .homepage .single-item, .homepage .single-re-item {
            padding: 20px;
            position: relative
        }

        .homepage .box-shadow {
            box-shadow: 0px 3px 5px 2px rgba(169, 159, 159, 0.75);
            -webkit-box-shadow: 0px 3px 5px 2px rgba(169, 159, 159, 0.75);
            -moz-box-shadow: 0px 3px 5px 2px rgba(169, 159, 159, 0.75);
        }

        .homepage .box-border {
            border: 2px #E2E7E6 solid;
        }

        .homepage .margin-bottom-30 {
            margin-bottom: 20px
        }

        .homepage .single-item h4, .homepage .single-re-item h4 {
            color: #0E8ACB;
            margin: 0;
            font-weight: 700;
            font-size: 24px;
            line-height: 30px;
        }

        .homepage .landing-section-2 .more, .homepage .events-section .more {
            margin-top: 10px;
            display: inline-block;
        }

            .homepage .landing-section-2 .more::after {
                vertical-align: text-bottom;
            }

            .homepage .events-section .more::after {
                vertical-align: text-top;
            }

        .homepage .single-item h6 {
            font-weight: 700;
            position: relative;
            padding-bottom: 5px;
            font-size: 16px
        }

        .homepage .span-extra2 {
        }

        .homepage .single-item p {
            max-width: calc(100% - 80px);
            line-height: 25px;
            margin-bottom: 0;
        }

        .homepage .single-re-item p {
            max-width: calc(100% - 80px);
            line-height: 25px;
            margin-bottom: 0;
        }

        .homepage .single-item .btn-more, .homepage .single-re-item .btn-more {
            position: absolute;
            right: 0;
            bottom: 0
        }

        .homepage .landing-section-2 .bx-wrapper {
            margin-top: 50px
        }

        .homepage .landing-section-2 .bx-viewport {
            overflow: visible !important
        }

        .homepage .landing-section-2 .bx-wrapper .bx-pager {
            text-align: left
        }

            .homepage .landing-section-2 .bx-wrapper .bx-pager.bx-default-pager a {
                width: 30px;
                height: 5px;
                background: #E6E6E6;
            }

                .homepage .landing-section-2 .bx-wrapper .bx-pager.bx-default-pager a.active {
                    background: #FCCD81;
                    border-color: #FCCD81;
                    height: 8px;
                    width: 40px;
                }

                .homepage .landing-section-2 .bx-wrapper .bx-pager.bx-default-pager a:hover {
                    background: #FAB84D;
                    border-color: #FAB84D;
                    height: 8px;
                    width: 40px;
                }

        .homepage .re-thumb {
            max-width: 100px;
            margin-top: -65px;
            float: left;
            background: #fff;
        }

            .homepage .re-thumb img {
                max-height: 135px;
            }

        .homepage .re-thumb-regfocus {
            max-width: 100px;
            margin-top: -50px;
            float: left;
            background: #fff;
            border: 1px #E2E7E6 solid;
        }

        .homepage .bx-wrapper .bx-pager {
            position: unset;
        }

        .homepage .re-auth-meta {
            width: calc(100% - 115px);
            margin-left: 15px;
            float: left;
            font-size: 14px;
            line-height: 20px !important;
            margin-bottom: 10px !important;
        }

        .homepage .re-msg a {
            font-family: 'Bitter'
        }

        .homepage .focus-auth-meta {
            width: calc(100% - 115px);
            margin-left: 20px;
            float: left;
            font-size: 14px;
            line-height: 20px !important;
            margin-bottom: 0px !important;
        }

        .homepage .blue-section {
            background: #0090BA;
            padding: 13px 15px;
            margin-bottom: 30px;
            margin-top: 20px;
            cursor: pointer;
        }

            .homepage .blue-section h2 {
                display: inline-block;
                color: transparent;
                font-weight: 900;
                font-size: 48px;
                margin-top: 0;
                font-family: Lato, sans-serif;
                ;
                line-height: 52px;
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
            }

            .homepage .blue-section p {
                font-size: 26px;
                font-weight: 300;
                color: #fff;
                margin-bottom: -5px
            }

        .homepage .management-step {
            padding: 30px;
            background-position: right center !important;
            background-repeat: no-repeat !important;
        }

        .homepage .management-content {
            min-height: 150px;
            text-align: center;
            color: #fff;
            padding: 14px;
            opacity: 0.85;
            cursor: pointer;
            padding-top: 30px;
            padding-bottom: 2px;
        }

            .homepage .management-content h4 {
                color: #fff;
                font-weight: 700
            }

        .homepage .events-section {
            margin: 30px 0 0px;
        }

        @media(max-width: 960px) {
            .homepage .events-section {
                max-width: 700px;
                width: 100%;
                margin: 0 auto;
            }
        }

        .homepage .sub-heading {
            font-weight: 700;
            margin-top: 0;
        }

        .homepage .events-inner-wrapper {
            margin-top: 50px;
            line-height: 1;
        }

        .homepage .event-item {
            margin-bottom: 20px;
            background-color: white;
        }

        .homepage .event-left-section {
            padding-top: 15px;
            padding-bottom: 15px
        }

            .homepage .event-left-section h5 {
                font-weight: 600;
                color: #444;
                line-height: 25px;
                margin-top: 0;
                font-size: 18px;
                min-height: 10px
            }

            .homepage .event-left-section p {
                margin-bottom: 0;
                font-weight: 600;
            }

                .homepage .event-left-section p span {
                    color: #0090BA;
                    font-weight: 600;
                    margin-left: 1px;
                }

        .homepage .event-right-section {
            text-align: center;
            font-size: small;
        }

            .homepage .event-right-section a {
                text-decoration: none;
                outline: 0;
                font-weight: bold;
                font-size: large;
                color: #19204a !important;
                min-height: 60px;
                line-height: 60px;
                display: block
            }

        @media(min-width: 961px) {
            .homepage .event-right-section a {
                min-height: 117px;
                line-height: 150px;
            }
        }

        .homepage .event-calendar img {
            display: block;
            width: 100%;
            max-width: 400px;
            margin: 0 auto
        }

        .homepage .new-section {
            padding: 32px 0;
            background: url("../images/brand-texture.gif");
            background-position: left top;
        }

            .homepage .new-section h2 {
                margin-bottom: 30px
            }

        .homepage .news-item {
            background: #fff;
            padding: 50px 30px 30px;
            position: relative;
            margin: 3px
        }

            .homepage .news-item a {
                text-decoration: none;
                outline: 0
            }

        .homepage .news-category {
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            padding: 10px 20px 5px 35px;
            display: inline-block;
            background: #0090BA;
            color: #fff !important;
            text-transform: uppercase;
            background-repeat: no-repeat !important;
            background-position: 8px center !important;
        }

            .homepage .news-category:after {
                font-family: icomoon;
                content: "\ea3c";
                margin-right: 10px;
                right: 0;
                position: absolute;
            }

        .homepage .news-title {
            font-size: 20px;
            font-weight: 700;
            color: #000 !important;
            display: block;
            margin-bottom: 5px;
            line-height: 1.2;
        }

        .homepage .news-item label {
            font-size: 14px
        }

        .homepage .news-content {
            font-weight: 600;
            margin-bottom: 0;
            color: #777;
            display: block
        }

        .homepage .news-item:hover .news-title, .news-item:hover label, .news-item:hover .news-content {
            color: #0090BA !important
        }

        .homepage .margin-top-30 {
            margin-top: 3px
        }

        .homepage .margin-top-subscribe {
            margin-top: 38px;
            margin-bottom: 7px;
        }

        .homepage .main-section-first {
            background-size: cover;
            width: 100%;
            height: auto;
            background-size: cover
        }

        .homepage .single-item {
            background-color: #fff;
            min-height: 229px;
        }

        .homepage .white-bg {
            background-color: #fff !important;
        }

        .homepage .owl-carousel .owl-item img {
            display: block;
            width: auto !important;
            margin: 0 auto;
        }

        .homepage #news_slider_first .item {
            padding: 0 10px !important;
        }

        .homepage #news_slider_first .owl-nav {
            margin: 0;
            position: absolute;
            top: 42%;
            left: 20px;
            right: 20px;
        }

        .homepage #news_slider_first .owl-dots {
            margin-top: 10px
        }

        .homepage #news_slider_first .owl-prev, .homepage #news_slider_first .owl-next {
            background: #fff url("../images/left-arrow.svg") no-repeat;
            background-position: 2px 50%;
            background-size: 15px;
            opacity: 1;
            width: 25px;
            height: 30px;
            text-indent: -999999px;
            font-size: 30px;
            margin: 0;
            float: left;
            border-radius: 0 50% 50% 0;
            outline: 0;
            margin-left: -20px;
            margin-right: -20px;
        }

        .homepage #news_slider_first .owl-next {
            background: #fff url("../images/right-arrow.svg") no-repeat;
            background-position: 6px 50%;
            background-size: 15px;
            float: right;
            border-radius: 50% 0 0 50%;
        }

        .homepage .event-calendar {
            text-align: -webkit-right;
            top: -64px;
        }

        .homepage .bx-viewport {
            height: 224px !important;
        }

        .homepage .landing-section-2 {
            padding-top: 4px;
        }

        .homepage .box-height {
            height: 229px;
        }

        .homepage .seealleventsright {
            margin-right: 35px;
        }

        .homepage .titlecolor {
            color: #000;
            margin: 0 0 3px;
        }

        .homepage .titlecolorAll {
            color: #009BC9;
            display: none;
        }

        .homepage .titlecolorviewmore {
        }

        .homepage .displayCalenderAll {
            visibility: hidden;
        }

        .homepage .blueLettersAll {
            color: #009BC9 !important;
            margin-top: 10px !important;
            float: right;
            margin-right: 25px;
            display: none !important;
        }

        .menu-visibility {
            visibility: hidden
        }

        .homepage .Calendar tbody tr:first-child tbody tr td:nth-child(2) {
            font-size: larger;
        }

        @media screen and (min-width: 1367px) {
            .homepage .event-item {
            }

            .homepage .sub-heading {
            }

            .homepage #news_slider_first > .owl-stage-outer > .owl-stage > .owl-item:nth-child(1) .item {
                padding-left: 0px !important;
                width: 350px !important
            }

            .homepage #news_slider_first > .owl-stage-outer > .owl-stage > .owl-item:nth-child(3) .item {
                padding-left: 20px !important;
            }

            .homepage #news_slider_first > .owl-stage-outer > .owl-stage > .owl-item:nth-child(4) .item {
                padding-right: 0px !important;
                padding-left: 20px !important;
            }
        }

        @media screen and (max-width: 1366px) {
            .homepage .sub-heading {
            }

            .homepage .event-item {
            }

            .homepage .blue-section {
                margin-left: 20px;
                margin-right: 20px;
            }

            .homepage .main-section-first {
                margin-left: 20px;
                margin-right: 20px;
                width: 97%;
            }

            .homepage #news_slider_first > .owl-stage-outer > .owl-stage > .owl-item:nth-child(1) .item {
                padding-left: 20px !important;
            }

            .homepage #news_slider_first > .owl-stage-outer > .owl-stage > .owl-item:nth-child(4) .item {
                padding-right: 20px !important;
            }
        }

        @media screen and (max-width: 1024px) {
            .homepage .event-item {
            }

            .homepage .sub-heading {
            }

            .homepage .blue-section {
                margin-left: 0px;
                margin-right: 0px;
            }

            .homepage .main-section-first {
                margin-left: 0px;
                margin-right: 0px;
                width: 100%;
            }

            .homepage #news_slider_first > .owl-stage-outer > .owl-stage > .owl-item:nth-child(1) .item {
                padding-left: 0px !important;
            }

            .homepage #news_slider_first > .owl-stage-outer > .owl-stage > .owl-item:nth-child(2) .item {
                padding-right: 0px !important;
            }

            .homepage #news_slider_first > .owl-stage-outer > .owl-stage > .owl-item:nth-child(3) .item {
                padding-left: 0px !important;
            }

            .homepage #news_slider_first > .owl-stage-outer > .owl-stage > .owl-item:nth-child(4) .item {
                padding-right: 0px !important;
            }

            .homepage .addmarginbottom {
                margin-bottom: 0px;
            }

            .homepage .titlecolorviewmore {
                letter-spacing: 0px;
            }

            .homepage .Calendar tbody tr:first-child tbody tr td:nth-child(2) {
                font-size: smaller;
            }

            .menu-visibility {
                visibility: visible;
            }

            .homepage .blueLettersAll {
                color: #009BC9 !important;
                margin-top: 10px !important;
                float: right;
                margin-right: 25px;
                display: none !important;
            }

            .homepage .displayCalenderAll {
                visibility: hidden;
            }

            .homepage .titlecolor {
                color: #fff;
            }

            .homepage .titlecolorAll {
                color: #009BC9;
                display: none;
            }

            .homepage .titlecolorviewmore {
                color: #fff;
            }

            .homepage .seealleventsright {
                margin-right: -55px;
            }

            .homepage .box-height {
                height: auto;
            }

            .homepage .landing-section-2 {
                padding-top: 40px;
                padding-bottom: 40px
            }

            .homepage .bx-viewport {
                height: 300px !important;
            }

            .homepage .eventleft {
                margin-left: -8px;
                font-size: inherit;
            }

            .homepage .event-calendar {
                overflow-x: scroll;
            }
        }

        @media screen and (max-width: 960px) {
            .homepage .event-item {
                margin-bottom: 20px;
            }

            .homepage .sub-heading {
                font-weight: 700;
                margin-top: 0;
                color: #000;
            }

            .homepage .addmarginbottom {
                margin-bottom: 0px;
            }

            .homepage .titlecolorviewmore {
                letter-spacing: 2px;
            }

            .homepage .blueLettersAll {
                color: #009BC9 !important;
                margin-top: 10px !important;
                float: right;
                margin-right: 25px !important;
                display: block !important;
                text-transform: none;
            }

            .homepage .displayCalenderAll {
                visibility: hidden;
            }

            .homepage .titlecolor {
                color: #fff;
            }

            .homepage .titlecolorAll {
                color: #009BC9;
                display: none;
            }

            .homepage .titlecolorviewmore {
                color: #fff;
            }

            .homepage .seealleventsright {
                margin-right: 35px;
            }

            .homepage .box-height {
                height: 200px;
            }

            .homepage .Calendar {
                display: none;
            }

            .homepage .landing-section-2 {
                padding-top: 40px;
                padding-bottom: 40px
            }

            .homepage .bx-viewport {
                height: 200px !important;
            }

            .homepage .eventleft {
                margin-left: 0px;
            }

            .margon-top-risk {
                margin-top: 0px;
            }

            .homepage .blue-section h2 {
                font-size: 63px;
                line-height: 55px;
            }

            .homepage .event-calendar {
                top: 0px;
                overflow-x: scroll;
            }

            .homepage .Calendar td, th {
                padding: 14px;
            }

            .homepage .landing-section-1 h1 {
                margin-top: 30px
            }
        }

        @media screen and (max-width: 768px) {
            .homepage .addmarginbottom {
                margin-bottom: 0px;
            }

            .homepage .landing-section-2 .more:after, .homepage .events-section .more:after, .homepage .new-section .more:after {
                display: none;
            }

            .homepage .displayCalenderAll {
                visibility: visible;
            }

            .homepage .titlecolor {
                color: #fff;
            }

            .homepage .titlecolorAll {
                color: #009BC9;
                display: block;
                text-transform: none;
            }

            .homepage .titlecolorviewmore {
                color: #fff;
                display: none;
            }

            .homepage .box-height {
                height: 235px;
            }

            .homepage .landing-section-2 {
                padding-top: 40px;
                padding-bottom: 40px
            }

            .homepage .bx-viewport {
                height: 250px !important;
            }

            .homepage .eventleft {
                margin-left: 0px;
            }

            .margon-top-risk {
                margin-top: 0px;
            }

            .homepage .blue-section h2 {
                font-size: 60px;
                line-height: 50px;
            }

            .homepage .event-calendar {
                top: 0px;
                overflow-x: scroll;
            }

            .homepage .Calendar td, th {
                padding: 14px;
            }

            .homepage .blue-section {
                margin-bottom: 28px;
                text-align: center;
            }

            .homepage .events-inner-wrapper {
                margin-top: 20px;
            }

            .homepage .event-left-section h5 {
            }

            .homepage .event-right-section a {
                min-height: 100%;
                line-height: 60px
            }
        }

        @media screen and (max-width: 568px) {
            .homepage #news_slider_first > .owl-stage-outer > .owl-stage > .owl-item:nth-child(1) .item {
                padding-left: 0px !important;
                padding-right: 0px !important;
            }

            .homepage #news_slider_first > .owl-stage-outer > .owl-stage > .owl-item:nth-child(2) .item {
                padding-left: 0px !important;
                padding-right: 0px !important;
            }

            .homepage #news_slider_first > .owl-stage-outer > .owl-stage > .owl-item:nth-child(3) .item {
                padding-left: 0px !important;
                padding-right: 0px !important;
            }

            .homepage #news_slider_first > .owl-stage-outer > .owl-stage > .owl-item:nth-child(4) .item {
                padding-left: 0px !important;
                padding-right: 0px !important;
            }
        }

        @media screen and (max-width: 480px) {
            .homepage .addmarginbottom {
                margin-bottom: 10px;
            }

            .homepage .titlecolor {
                color: #fff;
                margin-top: 5px !important;
            }

            .homepage .titlecolorAll {
                color: #009BC9;
                display: block;
                margin-top: 5px !important;
                text-transform: none;
            }

            .homepage .titlecolorviewmore {
                color: #009BC9;
                display: none;
            }

            .homepage .box-height {
                height: auto;
            }

            .homepage .landing-section-2 {
                padding-top: 0px;
                padding-bottom: 0px
            }

            .homepage .bx-viewport {
                height: 292px !important;
            }

            .homepage .eventleft {
                margin-left: 0px;
            }

            homepage .blue-section {
                margin-top: 20px;
            }

            .margon-top-risk {
                margin-top: 0px;
            }

            .homepage .blue-section h2 {
                font-size: 37px;
                line-height: 44px;
            }

            .homepage .event-calendar {
                top: 0px;
                overflow-x: scroll;
            }

            .homepage .Calendar td, th {
                padding: 14px;
            }

            .homepage .landing-section-1 a.btn-default {
                width: 100%
            }

            .homepage .landing-section-2 h3 {
                font-size: 22px
            }

            .homepage .landing-section-2 .bx-wrapper .bx-pager {
                text-align: center
            }

            .homepage .blue-section p {
                font-size: 20px
            }

            .homepage .landing-section-2 .more, .homepage .events-section .more {
                margin-top: 5px
            }

            .homepage .main-section-first {
            }

            .homepage .span-extra1 {
                display: block;
            }

            .homepage .datedivder {
                display: none;
            }
        }

        @media screen and (max-width: 320px) {
            .homepage .addmarginbottom {
                margin-bottom: 0px;
            }

            .homepage .box-height {
                height: auto;
            }

            .homepage .landing-section-2 {
                padding-top: 10px;
                padding-bottom: 0px
            }

            .homepage .bx-viewport {
                height: 323px !important;
            }

            .homepage .eventleft {
                margin-left: 0px;
            }

            .homepage .blue-section {
                margin-top: 430px;
            }

            .margon-top-risk {
                margin-top: 0px;
            }

            .homepage .blue-section h2 {
                font-size: 32px;
                line-height: 44px;
            }

            .homepage .event-calendar {
                top: -30px;
                overflow-x: scroll;
            }

            .homepage .Calendar td, th {
                padding: 14px;
            }

            .homepage .main-section-first {
                height: 383px;
            }
        }

        .homepage .Calendar td {
            border: none !important;
        }

        .homepage .Calendar tr th {
            background: none !important;
        }

        .homepage .Calendar tr td th {
            border: none !important;
        }

        .homepage .Calendar tr th {
            border: none !important;
            color: #19204A !important;
        }

        .homepage .Calendar table {
            border: none !important;
        }

        .homepage .Calendar tr td {
            background: none !important;
        }

        .homepage .Calendar .today {
            background-color: #FFD200 !important;
            width: -7% !important;
            width: 50px !important;
            height: 50px;
            border-radius: 250px;
            text-align: center;
            background: red;
            float: left;
            margin-left: 7px;
            padding-top: 15px;
        }

        .homepage .Calendar .todayie {
            background-color: #FFD200 !important;
            width: -7% !important;
            width: 50px !important;
            height: 60px;
            border-radius: 250px;
            text-align: center;
            background: red;
            float: none;
            margin-left: 7px;
            margin-top: 11px;
        }

        .homepage .Calendar .todayselected {
            background-color: #19204A !important;
            width: 50px !important;
            height: 44px;
            border-radius: 250px;
            text-align: center;
            float: left;
            margin-right: 10px;
            margin-left: 10px;
            margin-top: 5px;
            font-weight: bold;
            font-size: x-large;
            padding-top: 8px;
        }

            .homepage .Calendar .todayselected a {
                color: #BADDFB !important;
            }

        .homepage .Calendar .selecteddate {
            background-color: #0090BA !important;
            width: -7% !important;
            width: 50px !important;
            height: 50px;
            border-radius: 250px;
            text-align: center;
            background: red;
            float: left;
            margin-right: 10px;
            margin-left: 10px;
        }

        .homepage .Calendar .eventstyle {
            font-weight: bold;
            color: #000;
            font-size: x-large;
        }

        @media (max-width: 768px) {
            .homepage .cal-padding-2 {
            }
        }

        @media (min-width: 48.063em) {
            .homepage td, .homepage th {
                font-size: 18px;
                padding: 12px;
            }
        }

        .homepage .Calendar tbody tr:first-child tbody tr:first-child {
            margin-top: 5px;
            border-bottom: solid 0.5px #19204A;
        }

        .homepage .Calendar tbody tr:first-child tbody tr td:first-child {
            padding-left: 65px;
        }

        .homepage .Calendar tbody tr:first-child tbody tr td:last-child {
            padding-right: 100px !important;
        }

        .homepage .Calendar td {
            color: #19204A;
        }

        .homepage .Calendar tbody tr:first-child tbody tr td:nth-child(2) {
            text-align: center;
            font-weight: bold;
        }

        .homepage .more {
            position: relative;
            padding-right: 0px;
            transition: .3s all
        }

        .homepage .margin-bottom-reg {
            margin: 10px 5px;
            padding: 1px;
        }

        .homepage .prevnextmonthStyle > a {
            font-size: xx-large;
            color: #777 !important;
        }

        .homepage .bx-wrapper .bx-pager {
            margin-left: -5px;
        }

        .homepage .align-left, th {
            text-align: center;
        }

        .homepage .colorwhite {
            color: #fff;
        }

        .homepage .blackLetters {
            color: #000 !important;
        }

        .homepage .blueLetters {
            color: #009BC9 !important;
            top: -45px;
            right: 10px;
            letter-spacing: 2px;
        }

        .homepage .regexchangeht {
            margin-bottom: 5px;
        }

        .homepage .borderregex {
            border: 1px #E2E7E6 solid;
        }

        .homepage .pillertitle {
            margin-bottom: 5px;
            margin-top: 22px;
        }

        .homepage .btn-enroll {
            padding: 14px 16px !important;
        }

        .homepage .rmclass {
            opacity: 0.5;
            color: white;
        }

        .homepage .lineheightreduced {
            line-height: 17px !important;
            font-size: 15px;
        }

        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
            .homepage .blue-section h2 span {
                color: white;
                opacity: 0.5;
            }

            .homepage .footerie {
                clear: both;
            }

            .homepage .heightie {
                min-height: 100px;
            }
        }

        .homepage .news-head {
            margin-top: -4px;
        }

        .homepage .pillerwidth {
            width: 354px !important;
        }

        .homepage .margintop {
            margin-top: 12px;
        }

        .homepage .calendar_pad {
            padding-right: 0px;
        }

        .homepage .pad-0 {
            padding-left: 0px;
            margin-top: -3px;
            margin-bottom: 8px;
            padding-right: 0px;
        }

        .homepage .cal-padding-0 {
            margin-bottom: -29px;
        }

        .homepage .piller-img-height {
            max-height: 57px;
        }

        .homepage .piller-description {
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
            line-height: 1.3;
            height: 80px;
        }

        .homepage .piller-header {
            margin-top: 27px;
        }

        .homepage .piller-width {
            width: 360px !important;
        }
    `}
    </style>

  )
}

export default HomepageStyles;